import { render, staticRenderFns } from "./SearchResultConfiguration.vue?vue&type=template&id=74dbbe86&"
import script from "./SearchResultConfiguration.vue?vue&type=script&lang=ts&"
export * from "./SearchResultConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports